import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const iconMap: Record<string, string> = {
  'ri-group-line': 'ri-group-line',
  'ri-exchange-line': 'ri-exchange-line',
  'ri-hearts-line': 'ri-hearts-line',
  'ri-brain-line': 'ri-brain-line',
};

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
            探索内容分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            四大内容板块，系统性地帮你掌握社交拓展的全部技能
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-3 left-3 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 text-primary-500">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
                  <span>{cat.articleCount} 篇文章</span>
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}